import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { Tooltip as BootstrapTooltip, OverlayTrigger } from 'react-bootstrap';
import styled from '@emotion/styled';
import colours from '~/utils/colours';

const Wrapper = styled.div`
  display: flex;
  font-weight: bold;
  margin-bottom: 12px;
`;

const ImageIcon = styled.img`
  margin-right: 10px;
`;

const HelpContent = styled.div`
  text-align: center;
`;

const Title = styled.span`
  margin-right: 5px;
  color: ${colours.greyDarkAlt2};
`;

const HelpIcon = styled(FontAwesomeIcon)`
  color: ${colours.greyDarkAlt7};
`;

export interface HeadlineProps {
  imageIcon?: string;
  title: string;
  id: string;
  helpContent?: React.ReactNode;
  helpIcon?: IconDefinition;
  helpTextAlignMent?: string;
  className?: string;
  tooltipHideDelay?: number;
}

const Headline = ({
  imageIcon,
  title,
  id,
  helpContent,
  helpIcon,
  className,
  tooltipHideDelay = 400,
}: HeadlineProps) => {
  const tooltip = (
    <BootstrapTooltip id={id}>
      <HelpContent>{helpContent}</HelpContent>
    </BootstrapTooltip>
  );

  return (
    <Wrapper className={className}>
      {imageIcon && <ImageIcon src={imageIcon} />}
      <Title>{title}</Title>

      {helpContent && (
        <OverlayTrigger
          placement='right'
          overlay={tooltip}
          delayShow={250}
          delayHide={tooltipHideDelay}
        >
          <div>
            <HelpIcon icon={helpIcon ?? faInfoCircle} />
          </div>
        </OverlayTrigger>
      )}
    </Wrapper>
  );
};

export default Headline;
